import { MenuItemWithIcon } from "@msys/ui";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Divider } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import type {
  ItemType,
  PermissionName,
} from "../../../clients/graphqlTypes.js";
import { DecisionWizardButtons } from "../projects/quote-trees.js";

interface Props {
  projectId: string;
  quoteId: string;
  item: { id: string; type: ItemType };
  quote: {
    id: string;
    owningSystemOrganisationId: string;
    viewerPermissions: PermissionName[];
  };
  navigateToItem: (id: string) => void;
}

export const QuoteItemContextMenuItems = ({
  projectId,
  item,
  quote,
  navigateToItem,
}: Props) => {
  const { t } = useTranslate(["QuoteItem"]);
  return (
    <>
      <MenuItemWithIcon
        onClick={() => navigateToItem(item.id)}
        icon={<OpenInNewIcon />}
      >
        {t("Open item", { ns: "QuoteItem" })}
      </MenuItemWithIcon>
      <DecisionWizardButtons
        projectId={projectId}
        quote={quote}
        item={item}
        type="menu-item"
      />
      <Divider />
    </>
  );
};
